var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "resourceConfig" },
    [
      _c(
        "div",
        { staticClass: "leftBox" },
        [
          _c(
            "basic-container",
            [
              _c("el-card", { staticClass: "box-card" }, [
                _c(
                  "div",
                  {
                    staticClass: "clearfix",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [_c("span", [_vm._v("资源组")])]
                ),
                _c(
                  "div",
                  { staticClass: "query-form-wrap" },
                  [
                    _c(
                      "el-form",
                      {
                        attrs: {
                          inline: true,
                          model: _vm.searchForm,
                          size: _vm.formSize,
                        },
                      },
                      [
                        _c(
                          "el-form-item",
                          [
                            _c("el-input", {
                              attrs: { placeholder: "资源组编号" },
                              model: {
                                value: _vm.searchForm.code,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "code", $$v)
                                },
                                expression: "searchForm.code",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          [
                            _c("el-input", {
                              attrs: { placeholder: "名称" },
                              model: {
                                value: _vm.searchForm.name,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "name", $$v)
                                },
                                expression: "searchForm.name",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  size: "small",
                                  filterable: "",
                                  clearable: "",
                                  placeholder: "客户端类型",
                                },
                                model: {
                                  value: _vm.searchForm.clientType,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.searchForm, "clientType", $$v)
                                  },
                                  expression: "searchForm.clientType",
                                },
                              },
                              _vm._l(
                                _vm.AppBizdictClientTypeList,
                                function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.bizValue,
                                      value: item.bizKey,
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  size: "small",
                                  filterable: "",
                                  clearable: "",
                                  placeholder: "标签",
                                },
                                model: {
                                  value: _vm.searchForm.tag,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.searchForm, "tag", $$v)
                                  },
                                  expression: "searchForm.tag",
                                },
                              },
                              _vm._l(
                                _vm.AppBizdictTagsList,
                                function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.bizValue,
                                      value: item.bizKey,
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          [
                            _c("el-date-picker", {
                              attrs: {
                                type: "daterange",
                                "value-format": "yyyy-MM-dd",
                                "range-separator": "至",
                                "start-placeholder": "更新开始日期",
                                "end-placeholder": "更新结束日期",
                              },
                              model: {
                                value: _vm.searchForm.date,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "date", $$v)
                                },
                                expression: "searchForm.date",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  loading: _vm.listLoading,
                                  icon: "el-icon-search",
                                  type: "primary",
                                },
                                on: { click: _vm.doSearch },
                              },
                              [_vm._v("查询")]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "success",
                                  plain: "",
                                  icon: "el-icon-delete",
                                },
                                on: { click: _vm.searchClear },
                              },
                              [_vm._v("清空")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "clearfix" },
                  [
                    _c(
                      "avue-crud",
                      {
                        ref: "crud",
                        attrs: {
                          option: _vm.optionParent,
                          "table-loading": _vm.loading,
                          data: _vm.dataParent,
                          page: _vm.pageParent,
                          permission: _vm.permissionList,
                          "before-open": _vm.beforeOpen,
                          "upload-error": _vm.uploadError,
                          "upload-before": _vm.uploadBefore,
                        },
                        on: {
                          "row-del": _vm.rowDel,
                          "row-update": _vm.rowUpdate,
                          "row-save": _vm.rowSave,
                          "row-click": _vm.handleRowClick,
                          "search-change": _vm.searchChange,
                          "search-reset": _vm.searchReset,
                          "selection-change": _vm.selectionChange,
                          "current-change": _vm.currentChange,
                          "size-change": _vm.sizeChange,
                          "refresh-change": _vm.refreshChange,
                          "on-load": _vm.onLoadParent,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "screenshotUrl",
                            fn: function ({ row }) {
                              return [
                                _c("el-image", {
                                  staticStyle: {
                                    width: "100px",
                                    height: "50px",
                                    cursor: "pointer",
                                  },
                                  attrs: { src: row.screenshotUrl },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleShowImage(
                                        row.screenshotUrl
                                      )
                                    },
                                  },
                                }),
                              ]
                            },
                          },
                          {
                            key: "clientType",
                            fn: function ({ row }) {
                              return [
                                row.clientType
                                  ? _c(
                                      "div",
                                      _vm._l(
                                        row.clientType.split(","),
                                        function (item, index) {
                                          return _c(
                                            "el-tag",
                                            {
                                              key: index,
                                              staticStyle: { margin: "3px" },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.showClientTypeName(
                                                      item,
                                                      _vm.AppBizdictClientTypeList
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                          {
                            key: "tags",
                            fn: function ({ row }) {
                              return [
                                row.tags
                                  ? _c(
                                      "div",
                                      _vm._l(
                                        row.tags.split(","),
                                        function (item, index) {
                                          return _c(
                                            "el-tag",
                                            {
                                              key: index,
                                              staticStyle: { margin: "3px" },
                                              attrs: { type: "danger" },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.showClientTypeName(
                                                      item,
                                                      _vm.AppBizdictTagsList
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                          {
                            key: "isSealed",
                            fn: function ({ row }) {
                              return [
                                _c("el-tag", [
                                  _vm._v(
                                    _vm._s(row.isSealed === 0 ? "否" : "是")
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                        model: {
                          value: _vm.formParent,
                          callback: function ($$v) {
                            _vm.formParent = $$v
                          },
                          expression: "formParent",
                        },
                      },
                      [
                        _c(
                          "template",
                          { slot: "menuLeft" },
                          [
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "auth",
                                    rawName: "v-auth",
                                    value: "resourceConfig_log_hit_query",
                                    expression:
                                      "'resourceConfig_log_hit_query'",
                                  },
                                ],
                                attrs: { type: "primary", size: "small" },
                                on: { click: _vm.handleHitQuery },
                              },
                              [
                                _vm._v(
                                  "\n                命中查询\n              "
                                ),
                              ]
                            ),
                            _vm.permission.dict_delete
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "danger",
                                      size: "small",
                                      icon: "el-icon-delete",
                                      plain: "",
                                    },
                                    on: { click: _vm.handleDelete },
                                  },
                                  [
                                    _vm._v(
                                      "\n                删 除\n              "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c("template", { slot: "tipsForm" }, [
                          _c("div", { staticClass: "tipsForm" }, [
                            _c("div", { staticClass: "tit" }, [
                              _vm._v("命名规范"),
                            ]),
                            _c("div", { staticClass: "rules" }, [
                              _vm._v("1. "),
                              _c("strong", [_vm._v("资源组编号")]),
                              _vm._v("采用功能位置的英文小写+下划线的形式命名"),
                            ]),
                            _c("div", { staticClass: "rules_ex" }, [
                              _vm._v(
                                '例如：移动安卓首页轮播 ===> "app_android_home_banner"'
                              ),
                            ]),
                            _c("div", { staticClass: "rules" }, [
                              _vm._v("2. "),
                              _c("strong", [_vm._v("资源组名称")]),
                              _vm._v("尽可能完整描述功能及位置"),
                            ]),
                            _c("div", { staticClass: "rules_ex" }, [
                              _vm._v("例如：移动端安卓首页轮播"),
                            ]),
                            _c("div", { staticClass: "rules" }, [
                              _vm._v("3. "),
                              _c("strong", [_vm._v("标签")]),
                              _vm._v(
                                "勾选对应功能模块，便于日后易于检索及维护"
                              ),
                            ]),
                          ]),
                        ]),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("dragAdjustWidth", { attrs: { wrapperBox: "resourceConfig" } }),
      _c(
        "div",
        { staticClass: "rightBox" },
        [
          _c(
            "basic-container",
            [
              _c("el-card", { staticClass: "box-card" }, [
                _c(
                  "div",
                  {
                    staticClass: "clearfix",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [
                    _c("span", [
                      _vm._v("[" + _vm._s(_vm.dictValue) + "] 资源配置"),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "search-add-row" },
                  [
                    _c(
                      "el-form",
                      { attrs: { inline: true, model: _vm.childQuery } },
                      [
                        _c(
                          "el-form-item",
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "资源位code",
                                clearable: "",
                              },
                              model: {
                                value: _vm.childQuery.code,
                                callback: function ($$v) {
                                  _vm.$set(_vm.childQuery, "code", $$v)
                                },
                                expression: "childQuery.code",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "标题&描述",
                                clearable: "",
                              },
                              model: {
                                value: _vm.childQuery.title,
                                callback: function ($$v) {
                                  _vm.$set(_vm.childQuery, "title", $$v)
                                },
                                expression: "childQuery.title",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  placeholder: "用户标签",
                                  clearable: "",
                                  multiple: "",
                                  filterable: "",
                                },
                                model: {
                                  value: _vm.childQuery.userTags,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.childQuery, "userTags", $$v)
                                  },
                                  expression: "childQuery.userTags",
                                },
                              },
                              _vm._l(_vm.userTagsList, function (item) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: {
                                    label: `(${item.id}) ${item.tag}`,
                                    value: item.tag,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { placeholder: "状态", clearable: "" },
                                model: {
                                  value: _vm.childQuery.status,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.childQuery, "status", $$v)
                                  },
                                  expression: "childQuery.status",
                                },
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "上架", value: 1 },
                                }),
                                _c("el-option", {
                                  attrs: { label: "下架", value: 2 },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  placeholder: "审核状态",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.childQuery.auditStatus,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.childQuery, "auditStatus", $$v)
                                  },
                                  expression: "childQuery.auditStatus",
                                },
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "草稿", value: 1 },
                                }),
                                _c("el-option", {
                                  attrs: { label: "审核中", value: 2 },
                                }),
                                _c("el-option", {
                                  attrs: { label: "审核通过", value: 3 },
                                }),
                                _c("el-option", {
                                  attrs: { label: "审核不通过", value: 4 },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "clearfix" },
                  [
                    _c(
                      "avue-crud",
                      {
                        ref: "crudChild",
                        attrs: {
                          option: _vm.optionChild,
                          "table-loading": _vm.loadingChild,
                          data: _vm.dataChild,
                          permission: _vm.permissionList,
                          "before-open": _vm.beforeOpenChild,
                          "upload-before": _vm.uploadBefore,
                          "upload-after": _vm.uploadAfter,
                          "upload-error": _vm.uploadError,
                          "span-method": _vm.handleTableSpan,
                        },
                        on: {
                          "row-update": _vm.rowUpdateChild,
                          "row-save": _vm.rowSaveChild,
                          "selection-change": _vm.selectionChangeChild,
                          "current-change": _vm.currentChangeChild,
                          "size-change": _vm.sizeChangeChild,
                          "refresh-change": _vm.refreshChangeChild,
                          "on-load": _vm.onLoadChild,
                          rowAdd: _vm.handelChildAdd,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "index",
                              fn: function ({ row }) {
                                return [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.getMergedIndexText(
                                          row,
                                          _vm.getRowIndex(row)
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              },
                            },
                            {
                              key: "sortOrderOption",
                              fn: function ({ row }) {
                                return [
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        disabled: !_vm.isChildSearching,
                                        content: "请先清空搜索条件后再调整排序",
                                        placement: "top",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        [
                                          _vm.getRowIndex(row) !== 0
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "text",
                                                    disabled:
                                                      _vm.isChildSearching,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handleSortOrderOption(
                                                        row,
                                                        "up"
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("上移")]
                                              )
                                            : _vm._e(),
                                          _vm.canMoveDown(
                                            row,
                                            _vm.getRowIndex(row)
                                          )
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "text",
                                                    disabled:
                                                      _vm.isChildSearching,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handleSortOrderOption(
                                                        row,
                                                        "down"
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("下移")]
                                              )
                                            : _vm._e(),
                                          _vm.getRowIndex(row) !== 0
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "text",
                                                    disabled:
                                                      _vm.isChildSearching,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handleSortOrderOption(
                                                        row,
                                                        "top"
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("置顶")]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                            {
                              key: "menu",
                              fn: function ({ row }) {
                                return [
                                  row.auditStatus !== 2
                                    ? _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "auth",
                                              rawName: "v-auth",
                                              value: "resourceConfig_log",
                                              expression:
                                                "'resourceConfig_log'",
                                            },
                                          ],
                                          attrs: {
                                            type: "text",
                                            size: "small",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.openEditModal(row)
                                            },
                                          },
                                        },
                                        [_vm._v("编辑")]
                                      )
                                    : _vm._e(),
                                  row.auditStatus !== 2
                                    ? _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "auth",
                                              rawName: "v-auth",
                                              value: "resourceConfig_log",
                                              expression:
                                                "'resourceConfig_log'",
                                            },
                                          ],
                                          attrs: {
                                            type: "text",
                                            size: "small",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.rowDelChild(row)
                                            },
                                          },
                                        },
                                        [_vm._v("删除")]
                                      )
                                    : _vm._e(),
                                  row.auditStatus === 1 || row.auditStatus === 2
                                    ? _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "auth",
                                              rawName: "v-auth",
                                              value: "resourceConfig_log",
                                              expression:
                                                "'resourceConfig_log'",
                                            },
                                          ],
                                          attrs: {
                                            type: "text",
                                            size: "small",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleReview(row)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              row.auditStatus === 1
                                                ? "提交审核"
                                                : "撤销审核"
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "auth",
                                          rawName: "v-auth",
                                          value: "resourceConfig_log",
                                          expression: "'resourceConfig_log'",
                                        },
                                      ],
                                      attrs: { type: "text", size: "small" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleViewOperateLog(row)
                                        },
                                      },
                                    },
                                    [_vm._v("日志")]
                                  ),
                                ]
                              },
                            },
                            {
                              key: "icon",
                              fn: function ({ row }) {
                                return [
                                  row.icon
                                    ? _c("el-image", {
                                        staticStyle: {
                                          width: "100px",
                                          height: "50px",
                                          cursor: "pointer",
                                        },
                                        attrs: { src: row.icon },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleShowImage(
                                              row.image
                                            )
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                ]
                              },
                            },
                            {
                              key: "image",
                              fn: function ({ row }) {
                                return [
                                  row.image && row.image.indexOf(".mp4") !== -1
                                    ? _c("video", {
                                        staticStyle: {
                                          width: "100px",
                                          height: "50px",
                                          cursor: "pointer",
                                        },
                                        attrs: { src: row.image },
                                        on: {
                                          click: function ($event) {
                                            return _vm.showImage(
                                              row.image,
                                              "video"
                                            )
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                  row.image && row.image.trim()
                                    ? _c("el-image", {
                                        staticStyle: {
                                          width: "100px",
                                          height: "50px",
                                          cursor: "pointer",
                                        },
                                        attrs: { src: row.image },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleShowImage(
                                              row.image
                                            )
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                ]
                              },
                            },
                            {
                              key: "video",
                              fn: function ({ row }) {
                                return [
                                  row.video
                                    ? _c("video", {
                                        staticStyle: {
                                          width: "100px",
                                          height: "50px",
                                          cursor: "pointer",
                                        },
                                        attrs: { src: row.video },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleShowImage(
                                              row.video,
                                              "video"
                                            )
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                ]
                              },
                            },
                            {
                              key: "richTextForm",
                              fn: function ({ row }) {
                                return [
                                  row.richTextMode === _vm.richTextModePure
                                    ? _c("el-input", {
                                        attrs: {
                                          type: "textarea",
                                          autosize: { minRows: 8, maxRows: 20 },
                                          placeholder:
                                            "纯内容模式：内容原样保存，不做任何转换",
                                        },
                                        model: {
                                          value: row.richText,
                                          callback: function ($$v) {
                                            _vm.$set(row, "richText", $$v)
                                          },
                                          expression: "row.richText",
                                        },
                                      })
                                    : _c(
                                        "avue-ueditor",
                                        _vm._b(
                                          {
                                            ref: "editor",
                                            model: {
                                              value: row.richText,
                                              callback: function ($$v) {
                                                _vm.$set(row, "richText", $$v)
                                              },
                                              expression: "row.richText",
                                            },
                                          },
                                          "avue-ueditor",
                                          _vm.richTextOptions,
                                          false
                                        )
                                      ),
                                ]
                              },
                            },
                            {
                              key: "videoForm",
                              fn: function ({ row }) {
                                return [
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "el-upload",
                                        {
                                          staticClass: "upload-demo",
                                          attrs: {
                                            "before-upload":
                                              _vm.beforeVideoUpload,
                                            "http-request": _vm.videoUpload,
                                            "show-file-list": false,
                                          },
                                        },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                size: "medium",
                                                type: "primary",
                                              },
                                            },
                                            [_vm._v(" 上传 ")]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "uidsSlot_text" },
                                        [
                                          _vm.formChild.video
                                            ? _c(
                                                "a",
                                                {
                                                  staticStyle: {
                                                    outline: "none",
                                                    color: "skyblue",
                                                  },
                                                  attrs: {
                                                    href: _vm.formChild.video,
                                                    target: "_blank",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.formChild.video
                                                      ) +
                                                      "\n                  "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                            {
                              key: "uuidsForm",
                              fn: function ({ row }) {
                                return [
                                  _c("div", { staticClass: "uidsSlot" }, [
                                    _c(
                                      "div",
                                      { staticClass: "uidsSlot_btn" },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "_btn",
                                            attrs: {
                                              size: "mini",
                                              type: "primary",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.downloadTemplate(
                                                  row.id,
                                                  "exportUuids"
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("下载导入模板")]
                                        ),
                                        _c(
                                          "el-upload",
                                          {
                                            staticClass: "_btn",
                                            attrs: {
                                              "show-file-list": false,
                                              action: _vm.actionUUidUrl,
                                              "before-upload": _vm.beforeUpload,
                                              "on-success": (
                                                response,
                                                file
                                              ) => {
                                                _vm.uuidsUploadSuccess(
                                                  response,
                                                  file
                                                )
                                                row.uuids = response.data.uuids
                                              },
                                              headers: _vm.headers,
                                              multiple: false,
                                            },
                                          },
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  size: "mini",
                                                  type: "primary",
                                                },
                                              },
                                              [_vm._v(" 上传 ")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "uidsSlot_text" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.uuidsUploadData.name) +
                                            "\n                  "
                                        ),
                                        _c("span", [
                                          _vm._v(
                                            "\n                    成功上传" +
                                              _vm._s(
                                                _vm.uuidsUploadData.successNum
                                              ) +
                                              "，失败" +
                                              _vm._s(
                                                _vm.uuidsUploadData.failNum
                                              ) +
                                              "\n                  "
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "uidsForm",
                              fn: function ({ row }) {
                                return [
                                  _c("div", { staticClass: "uidsSlot" }, [
                                    _c(
                                      "div",
                                      { staticClass: "uidsSlot_btn" },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "_btn",
                                            attrs: {
                                              size: "mini",
                                              type: "primary",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.downloadTemplate(
                                                  row.id,
                                                  "exportUids"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "下载导入模板\n                  "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "el-upload",
                                          {
                                            staticClass: "_btn",
                                            attrs: {
                                              "show-file-list": false,
                                              action: _vm.actionUrl,
                                              "before-upload": _vm.beforeUpload,
                                              "on-success": (
                                                response,
                                                file
                                              ) => {
                                                _vm.uidsUploadSuccess(
                                                  response,
                                                  file
                                                )
                                                row.uids = response.data.uids
                                              },
                                              headers: _vm.headers,
                                              multiple: false,
                                            },
                                          },
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  size: "mini",
                                                  type: "primary",
                                                },
                                              },
                                              [_vm._v(" 上传 ")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "uidsSlot_text" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.uidsUploadData.name) +
                                            "\n                  "
                                        ),
                                        _c("span", [
                                          _vm._v(
                                            "\n                    成功上传" +
                                              _vm._s(
                                                _vm.uidsUploadData.successNum
                                              ) +
                                              "，失败" +
                                              _vm._s(
                                                _vm.uidsUploadData.failNum
                                              ) +
                                              "\n                  "
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "appidFilterList",
                              fn: function ({ row }) {
                                return [
                                  row.appidFilterNames
                                    ? [
                                        row.appidFilterNames.split(";").length <
                                        5
                                          ? _vm._l(
                                              row.appidFilterNames.split(";"),
                                              function (item, index) {
                                                return _c(
                                                  "el-tag",
                                                  { key: index },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(item) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                )
                                              }
                                            )
                                          : [
                                              _c("el-tag", [
                                                _vm._v(
                                                  _vm._s(
                                                    row.appidFilterNames.split(
                                                      ";"
                                                    )[0]
                                                  )
                                                ),
                                              ]),
                                              _c(
                                                "el-popover",
                                                {
                                                  attrs: {
                                                    placement: "right",
                                                    width: "400",
                                                    trigger: "click",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    _vm._l(
                                                      row.appidFilterNames.split(
                                                        ";"
                                                      ),
                                                      function (item, index) {
                                                        return _c(
                                                          "el-tag",
                                                          {
                                                            key: index,
                                                            attrs: {
                                                              size: "mini",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(item)
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    1
                                                  ),
                                                  _c(
                                                    "el-tag",
                                                    {
                                                      staticClass:
                                                        "el-icon-right",
                                                      attrs: {
                                                        slot: "reference",
                                                        size: "mini",
                                                      },
                                                      slot: "reference",
                                                    },
                                                    [_vm._v("展开更多")]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                      ]
                                    : _vm._e(),
                                ]
                              },
                            },
                            {
                              key: "userTagsForm",
                              fn: function ({ row }) {
                                return [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        multiple: "",
                                        filterable: "",
                                        "collapse-tags": "",
                                        placeholder: "请选择用户标签",
                                      },
                                      model: {
                                        value: row.userTags,
                                        callback: function ($$v) {
                                          _vm.$set(row, "userTags", $$v)
                                        },
                                        expression: "row.userTags",
                                      },
                                    },
                                    _vm._l(_vm.userTagsList, function (item) {
                                      return _c("el-option", {
                                        key: item.id,
                                        attrs: {
                                          label: `(${item.id})${item.tag}`,
                                          value: item.tag,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ]
                              },
                            },
                            {
                              key: "userTags",
                              fn: function ({ row }) {
                                return [
                                  row.userTags && row.userTags.length > 0
                                    ? _c(
                                        "div",
                                        _vm._l(row.userTags, function (tag) {
                                          return _c(
                                            "el-tag",
                                            {
                                              key: tag,
                                              staticStyle: { margin: "2px" },
                                              attrs: { size: "mini" },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.getUserTagName(tag)
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          )
                                        }),
                                        1
                                      )
                                    : _c("span", [_vm._v("-")]),
                                ]
                              },
                            },
                            {
                              key: "eventType",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.getEventTypeName(
                                          scope.dic,
                                          scope.row.eventType
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              },
                            },
                            {
                              key: "userTypes",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm._f("mapUserTagsToDict")(
                                          scope.row.userTypes,
                                          scope.dic
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              },
                            },
                            {
                              key: "appidFilterListForm",
                              fn: function (scope) {
                                return _vm.formChild.appidFilterType != 0
                                  ? [
                                      _c("el-input", {
                                        attrs: { type: "textarea" },
                                        on: {
                                          focus: function ($event) {
                                            return _vm.handleClick()
                                          },
                                        },
                                        model: {
                                          value: _vm.formChild.appidFilterNames,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formChild,
                                              "appidFilterNames",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formChild.appidFilterNames",
                                        },
                                      }),
                                    ]
                                  : undefined
                              },
                            },
                            {
                              key: "isSealed",
                              fn: function ({ row }) {
                                return [
                                  _c("el-tag", [
                                    _vm._v(
                                      _vm._s(row.isSealed === 0 ? "否" : "是")
                                    ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "eventBodyForm",
                              fn: function (scope) {
                                return [
                                  _c("el-input", {
                                    attrs: {
                                      type: "input",
                                      placeholder: "请输入响应",
                                    },
                                    nativeOn: {
                                      click: function ($event) {
                                        return _vm.handleResponseClick(
                                          scope.row
                                        )
                                      },
                                    },
                                    model: {
                                      value: _vm.formChild.eventBody,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formChild,
                                          "eventBody",
                                          $$v
                                        )
                                      },
                                      expression: "formChild.eventBody",
                                    },
                                  }),
                                ]
                              },
                            },
                            {
                              key: "codeSearch",
                              fn: function ({ row }) {
                                return [
                                  _c("el-input", {
                                    attrs: { placeholder: "请输入字典编号" },
                                    model: {
                                      value: _vm.childQuery.code,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.childQuery, "code", $$v)
                                      },
                                      expression: "childQuery.code",
                                    },
                                  }),
                                ]
                              },
                            },
                            {
                              key: "titleSearch",
                              fn: function ({ row }) {
                                return [
                                  _c("el-input", {
                                    attrs: { placeholder: "请输入标题" },
                                    model: {
                                      value: _vm.childQuery.title,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.childQuery, "title", $$v)
                                      },
                                      expression: "childQuery.title",
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: _vm.formChild,
                          callback: function ($$v) {
                            _vm.formChild = $$v
                          },
                          expression: "formChild",
                        },
                      },
                      [
                        _c(
                          "template",
                          { slot: "menuLeft" },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: { click: _vm.handleSearchChild },
                              },
                              [_vm._v("搜索")]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary", plain: "" },
                                on: { click: _vm.handleAddChild },
                              },
                              [_vm._v("新增")]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "warning", plain: "" },
                                on: { click: _vm.handleBatchReview },
                              },
                              [_vm._v("批量提交审核")]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "info", plain: "" },
                                on: { click: _vm.handleBatchReviewRecord },
                              },
                              [_vm._v("批量审核记录")]
                            ),
                          ],
                          1
                        ),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ]),
              _c("channel-popups", {
                attrs: {
                  isRabbittactics: true,
                  "app-id": _vm.formChild.appidFilterList,
                  visible: _vm.activityForm.showPopups,
                },
                on: {
                  "update:visible": function ($event) {
                    return _vm.$set(_vm.activityForm, "showPopups", $event)
                  },
                  comfirm: _vm.handleConfirm,
                },
              }),
              _c(
                "tow-dialog",
                {
                  attrs: {
                    visible: _vm.eventbodtForm.dialogVisible,
                    width: "800px",
                    dialogTitle: "事件响应",
                  },
                  on: {
                    "update:visible": function ($event) {
                      return _vm.$set(
                        _vm.eventbodtForm,
                        "dialogVisible",
                        $event
                      )
                    },
                    comfirm: _vm.callbackEvenBodyComfirm,
                  },
                },
                [
                  _c(
                    "template",
                    { slot: "form" },
                    [
                      _c(
                        "el-form",
                        {
                          attrs: {
                            model: _vm.eventbodtForm,
                            "label-width": "120px",
                            "label-position": "rigth",
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "事件响应类型" } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    clearable: "",
                                    placeholder: "请选择事件响应类型",
                                  },
                                  model: {
                                    value: _vm.eventbodtForm.pdata.action,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.eventbodtForm.pdata,
                                        "action",
                                        $$v
                                      )
                                    },
                                    expression: "eventbodtForm.pdata.action",
                                  },
                                },
                                _vm._l(
                                  _vm.eventbodtForm.action,
                                  function (item) {
                                    return _c("el-option", {
                                      key: item.id,
                                      attrs: {
                                        label: item.value,
                                        value: item.id,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "事件响应Code" } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 21 } },
                                [
                                  _c("selectBottom", {
                                    attrs: {
                                      selectedValue:
                                        _vm.eventbodtForm.pdata.actionCode,
                                    },
                                    on: { HanderSelected: _vm.getValue },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "是否付费专辑" } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    clearable: "",
                                    placeholder: "请选择专辑类型",
                                  },
                                  model: {
                                    value: _vm.eventbodtForm.pdata.isPay,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.eventbodtForm.pdata,
                                        "isPay",
                                        $$v
                                      )
                                    },
                                    expression: "eventbodtForm.pdata.isPay",
                                  },
                                },
                                _vm._l(
                                  _vm.eventbodtForm.isPay,
                                  function (item) {
                                    return _c("el-option", {
                                      key: item.id,
                                      attrs: {
                                        label: item.value,
                                        value: item.id,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "专辑ID" } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 21 } },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "请输入专辑ID" },
                                    model: {
                                      value: _vm.eventbodtForm.pdata.albumId,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.eventbodtForm.pdata,
                                          "albumId",
                                          $$v
                                        )
                                      },
                                      expression: "eventbodtForm.pdata.albumId",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
              _c(
                "tow-dialog",
                {
                  attrs: {
                    visible: _vm.screenCastEventForm.dialogVisible,
                    width: "600px",
                    dialogTitle: "事件响应",
                  },
                  on: {
                    "update:visible": function ($event) {
                      return _vm.$set(
                        _vm.screenCastEventForm,
                        "dialogVisible",
                        $event
                      )
                    },
                    comfirm: _vm.callbackScreenCastEventComfirm,
                  },
                },
                [
                  _c(
                    "template",
                    { slot: "form" },
                    [
                      _c(
                        "el-form",
                        {
                          attrs: {
                            model: _vm.screenCastEventForm,
                            "label-width": "120px",
                            "label-position": "rigth",
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "响应类型" } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    clearable: "",
                                    placeholder: "请选择响应类型",
                                  },
                                  model: {
                                    value:
                                      _vm.screenCastEventForm.pdata
                                        .responseType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.screenCastEventForm.pdata,
                                        "responseType",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "screenCastEventForm.pdata.responseType",
                                  },
                                },
                                _vm._l(
                                  _vm.screenCastResponseTypeList,
                                  function (item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("HitQueryDialog", { ref: "hitQueryDialogRef" }),
      _c("ResourceItemOperateLogDialog", {
        ref: "resourceItemOperateLogDialogRef",
      }),
      _c("ResourceBatchReviewDialog", {
        ref: "resourceBatchReviewDialogRef",
        on: {
          success: function ($event) {
            return _vm.onLoadChild(_vm.pageChild)
          },
        },
      }),
      _c("ResourceBatchReviewRecordDialog", {
        ref: "resourceBatchReviewRecordDialogRef",
        on: {
          success: function ($event) {
            return _vm.onLoadChild(_vm.pageChild)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }